import { useHotelStoreHook } from "@/distributions/consumer/y/store/hotel";
import { useToggles } from "@/hooks/useToggles";

/**
 * 根据 location 对象构建并保存搜索历史
 * @param {object} location - 完整的 location 对象
 */
export function recordLocationHistory(location) {
  const historyToggle = useToggles("Y_WEB_SEARCH_HISTORY");

  if (!location || !location.showLabel) return;
  if (!historyToggle.value) return;

  const YHotelStore = useHotelStoreHook();

  const payload = {
    type: "searchUniversal",
    text: location.showLabel,
    target: null,
    info: null
  };

  if (
    location.locationType === "moduleTpHotel" ||
    location.locationType === "city"
  ) {
    payload.target = {
      collectionName:
        location.locationType === "moduleTpHotel" ? "hotel" : "city",
      ref: location._id
    };
  } else if (location.locationType === "googleMapPolitical") {
    payload.info = {
      collectionName: "google",
      description: location.showLabel,
      place_id: location._id
    };
  } else if (location.locationType === "search") {
    payload.info = {
      collectionName: "keyword"
    };
  }

  return YHotelStore.setSearchHistory(payload);
}
